@if (user) {
  <section class="no-auth-page">
    <header>
      <h3>{{ isAnInvite ? 'Create password' : 'Reset your password' }}</h3>
    </header>
    <form [formGroup]="form" class="ht-form" (ngSubmit)="onSubmit()">
      <ht-input
        type="hidden"
        formControlName="email"
        style="display: none"
      ></ht-input>
      <div class="ht-form-item">
        <div class="ht-form-item-title">New password</div>
        <div class="ht-form-item-control">
          <ht-input
            label="Password"
            type="password"
            formControlName="password"
            [fullWidth]="true"
            helpText="Minimum 12 character long"
          ></ht-input>
        </div>
      </div>
      <div class="ht-form-item">
        <div class="ht-form-item-title">Repeat password</div>
        <div class="ht-form-item-control">
          <ht-input
            label="Repeat password"
            type="password"
            formControlName="checkPassword"
            [fullWidth]="true"
          ></ht-input>
        </div>
      </div>
      @if (form.errors?.serverError) {
        <div class="ht-form-row">
          <div class="error-alert">
            <i class="fa-solid fa-circle-xmark"></i>
            <span>{{ form.errors?.serverError }}</span>
          </div>
        </div>
      }
      <div class="ht-form-actions">
        <button
          ht-button-primary
          [fullWidth]="true"
          type="submit"
          size="large"
          [isLoading]="isLoading"
        >
          Save password
        </button>
      </div>
    </form>
  </section>
}
